// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1vTs5","bigColWidth":"Table_bigColWidth__1fJRJ","biggerColWidth":"Table_biggerColWidth__2U6fX","row":"Table_row__3w-jR","col":"Table_col__3SMX2"};